module.exports = __webpack_public_path__ + "akadem-district-photo.1597de008ce06e731bb8.png";


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/img/png-uk-akadem/akadem-district-photo.png
// module id = ../../../../../src/img/png-uk-akadem/akadem-district-photo.png
// module chunks = 5